/**
 * Case Figures API Service
 *
 * TypeScript client for the canonical case-figures endpoint. Returns the
 * net-supported claim, bottom-up BI loss, top-down BI loss, and gross loss
 * figures computed by the policy-deductions engine. These are the binding
 * numbers that headline the war-room and methodology pages.
 */

import { api } from '../utils/api';

export interface CaseFigureEntry {
  value: number | null;
  label: string;
  quantity: string;
  engine_id: string;
  run_id: string | null;
  computed_at: string | null;
}

export interface CaseFiguresResponse {
  report_id: string;
  figures: Partial<
    Record<
      | 'net_supported_claim'
      | 'bi_loss_bottom_up'
      | 'bi_loss_top_down'
      | 'gross_loss',
      CaseFigureEntry
    >
  >;
  snapshot_diverges: boolean;
  elected_method?: string;
}

/**
 * Fetch canonical case figures for a report.
 *
 * The endpoint is report-scoped and org-gated via `assert_user_can_access_report`.
 */
export function getCaseFigures(id: string) {
  return api.get<CaseFiguresResponse>(`/api/v1/case-figures/${id}`, { showErrorToast: false });
}
